import InfoService from '@/modules/core/services/info-service';
import Utils from '@/modules/core/services/utils';
import Vue from 'vue';
import { i18n } from '@/plugins/i18next'

export default class EnumUtils {

    static enumArray = [];

    static async loadEnum(url, module, enumName, responseF, errorF) {
        await InfoService.readEnum(url,
            (response) => {
                let enumArray = [];
                for(var i = 0; i < response.data.length; i++) {
                    enumArray.push({id: response.data[i]});
                }
                enumArray = this.translateAndSortEnums(module, enumName, enumArray);

                if (responseF) {
                    responseF(enumArray);
                }
            },
            (error) => {
                Vue.prototype.$logger.error("Error at InfoService.readEnum: " + error);
                Utils.showFailureSnackbar(i18n.i18next.t('snackbar:load-failure', {name: i18n.i18next.t(module + ':edit.snackbar.' + enumName)}));

                if (errorF) {
                    errorF(error);
                }
            }
        )
    }

    static translateAndSortEnums(module, enumName, enumArray) {
        for(var i = 0; i < enumArray.length; i++) {
            enumArray[i].translatedName = i18n.i18next.t('enums:' + module + '.' + enumName + '.' + enumArray[i].id);
        }
        this.sortEnum(enumArray);

        return enumArray;
    }


    /**
     * Sort enums
     * 
     * @param [] enumArray 
     */
     static sortEnum(enumArray) {
        enumArray.sort((a, b) => {
            if(a.translatedName < b.translatedName) {
                return -1;
            }

            if(a.translatedName > b.translatedName) {
                return 1;
            }

            return 0;
        })
    }
}